import { useState } from 'react';

import { startOperation } from '@mint-lib/datadog';
import { useTranslation } from '@mint-lib/i18n';
import { Import } from '@mint-lib/icons';
import { useMutationState } from '@mint-lib/query-client';
import {
  Button,
  Dialog,
  DialogOverlay,
  DialogTrigger,
} from '@mint-lib/tw-components';

import { IMPORT_VALIDATION_MUTATION_KEY } from '../../../../../../api/mutations/useImportActivity.js';
import { DialogContentImport } from './DialogContentImport.jsx';

export const ImportPlanModal = () => {
  const { t } = useTranslation('@myn/planning_v2');
  const [open, setOpen] = useState<boolean>(false);

  const status = useMutationState({
    filters: { mutationKey: IMPORT_VALIDATION_MUTATION_KEY },
    select: (state) => state.state.status,
  }).at(-1);

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen && status === 'pending') {
      return;
    }

    if (isOpen && !open) {
      // Ended by useImportPlan in the modal's content.
      startOperation('plan.import');
    }

    setOpen(isOpen);
  };

  return (
    <Dialog modal open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button
          variant="text"
          data-dd-action-name="Import activity modal: open"
        >
          <Import />
          {t('Import activity')}
        </Button>
      </DialogTrigger>

      <DialogOverlay data-dd-action-name="Import activity modal: close" />
      {open && <DialogContentImport handleOpenChange={handleOpenChange} />}
    </Dialog>
  );
};
